import { registerApplication, start } from "single-spa";

function isLoginRoute(pathname) {
  return pathname === "/v1/login" || pathname === "/login";
}

function isV1Route(pathname) {
  return pathname === "/v1" || pathname.startsWith("/v1/");
}

function isV2Route(pathname) {
  return pathname === "/v2" || pathname.startsWith("/v2/");
}

function isPixRoute(pathname) {
  return pathname === "/v2/pagamentos/pix" || pathname.startsWith("/v2/pagamentos/pix/");
}

// Layout (Shell) - skip on login for faster initial render
registerApplication({
  name: "@fibra/layout",
  app: () => System.import("@fibra/layout"),
  activeWhen: (location) => !isLoginRoute(location.pathname),
});

// Registro do App Angular — só /v1 (nunca /v2)
registerApplication({
  name: "@fibra/v1",
  app: () => System.import("@fibra/v1"),
  activeWhen: (location) => isV1Route(location.pathname),
});

// Registro do App React — /v2 exceto rotas PIX
registerApplication({
  name: "@fibra/react",
  app: () => System.import("@fibra/react"),
  activeWhen: (location) => isV2Route(location.pathname) && !isPixRoute(location.pathname),
});

// Registro do App React PIX — /v2/pagamentos/pix/*
registerApplication({
  name: "@fibra/react-pix",
  app: () => System.import("@fibra/react-pix"),
  activeWhen: (location) => isPixRoute(location.pathname),
});

start({
  urlRerouteOnly: true,
});

